import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
// import { IoDocumentTextOutline } from "react-icons/io5";
// import { TbReportSearch } from "react-icons/tb";
import "./ListReports.css"

export function ListReportComponent() {
    return (
        <Container>

            <div className="d-flex flex-wrap justify-content-center align-items-center box-reports-container">

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/ConcludeBorrow"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        สรุปข้อมูลการให้กู้ยืมเงิน<br />กองทุนพัฒนาฝีมือแรงงาน
                        {/* <p className="px-3">/p> */}
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-2"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3 px-3"
                    >
                        สรุปข้อมูลการอนุมัติและทำสัญญากู้ยืมเงิน<br />กองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-3"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        สรุปข้อมูลการชำระหนี้และหนี้ค้างชำระ
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-4"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        สรุปข้อมูลการให้กู้ยืมเงิน<br />กองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-5"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        สรุปข้อมูลการชำระคืนเงินกู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-6"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        หลักสูตรการฝึกอบรมของสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อพัฒนาศักยภาพลูกจ้าง<br/>ภายใต้พระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน<br/> พ.ศ. 2545
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-7"
                        style={{ textDecoration: "none"}}
                        className="content-reports px-3"
                    >
                        สรุปข้อมูลสถานประกอบกิจการที่กู้ยืมเงิน<br />กองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-8"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        สรุปข้อมูลการพัฒนาฝีมือแรงงานจากการกู้ยืมเงิน<br />กองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-9"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        สรุปข้อมูลขนาดสถานประกอบกิจการที่กู้ยืมเงิน<br />กองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-10"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ตารางสรุปการค้างชำระเงินกู้ยืม
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-11"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        สรุปผลการอนุมัติให้กู้ยืมเงิน และการชำระเงินคืนเงินคืนกองทุนพัฒนาฝีมือแรงงาน จำแนกตามรายชื่อสถานประกอบกิจการ
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-12"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        สรุปข้อมูลการอนุมัติให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน<br />(จำแนกตามหน่วยงานที่ให้กู้ยืมเงิน)
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-13"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        การจัดสรรเป้าหมายการให้กู้ยืมเงิน<br />กองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-14"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        แบบสรุปสถานประกอบกิจการที่กู้ยืมเงิน
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-15"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        แบบเก็บข้อมูลแบบติดตามประเมินผลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน (แบบ กย.6)
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-16"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        รายงานแบบสรุปแบบติดตามประเมินผลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-17"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ทะเบียนข้อมูลสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน ตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-18"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ทะเบียนข้อมูลสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน ตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-19"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        รายงานการติดตามการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานตามพระราชัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ.2545 และที่แก้ไขเพิ่มเติม ตามแบบ กย.8
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-201"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        รายงานการชำระเงินกู้ยืม<br />กองทุนพัฒนาฝีมือแรงงาน
                    </Link>
                </div>

                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 justify-content-center box-reports">
                    <Link
                        to="/borrowing/borrow/Reports/19-202"
                        style={{ textDecoration: "none" }}
                        className="content-reports px-3"
                    >
                        ข้อมูลทะเบียบคุมลูกหนี้เงินกู้ ตาม พระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                    </Link>
                </div>

            </div>

            <div class="boxes-tn">
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div>
            </div>
        </Container>
    )
}